import styled from "styled-components/macro";
import checkmark from "../../../../components/Icon/checked.svg";
import { shimmerOverlay } from "../../../components/Shimmer/Shimmer";

export const KanbanContainer = styled.div`
  padding-bottom: 20px;
  display: flex;
  height: calc(100% - 180px);
  max-height: 100%;
  width: ${(props) => (props.width ? props.width + "px" : "auto")};
  overflow-x: auto;
  /* overflow-y: hidden; */
  &::-webkit-scrollbar:horizontal {
    display: none;
    width: 0 !important;
  }
  -ms-overflow-style: auto;
  scrollbar-width: auto;
  width: 100%;
  opacity: 0;
  ${(props) =>
    !props.$loading &&
    `
  animation: opacity .5s ease;
  opacity: 1; 
  `}
  h2 {
    color: ${(props) => props.theme.colors.faceliftBlue};
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
    margin-top: 5px;
  }
  button {
    width: 100%;
    border: none;
    background-color: transparent;
  }
  .blue {
    background-color: ${(props) => props.theme.colors.faceliftBlue};
  }
  div[role="button"] {
    width: 100%;
  }
  @media (max-width: 992px) {
    height: calc(100% - 125px);
    padding-top: 20px;

    h2 {
      margin-top: 24px;
      margin-bottom: 16px;
    }
  }
`;

export const KanbanContainerWrapper = styled.div`
  margin-right: 20px;
  position: relative;
  height: 100%;

  &:first-of-type {
    margin-left: 20px;
    .anonymous-hiring {
      display: flex;
    }
  }

  @media (max-width: 992px) {
    margin-right: 24px;
    &:first-of-type {
      margin-left: 48px;
    }
  }
`;

export const KanbanColumnStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 360px;
  height: 100%;
  min-height: 816px;

  @media (max-width: 992px) {
    width: 280px;
    min-height: 816px;
  }
`;

export const KanbanSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: ${(props) => {
    if (props.$split) return "348px";
    if (props.$secondary) return "180px";
    return "0";
  }};
  flex: ${(props) => {
    if (props.$splitPrimary) return "0 1 auto";
    if (props.$splitSecondary) return "1 1 348px";
    if (props.$secondary) return "0 0 auto";
    return "1 1 auto";
  }};
`;

export const KanbanSectionTitle = styled.h3`
  color: ${(props) => props.theme.colors.faceliftBlue};
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 12px;
  opacity: 0.7;
`;

export const KanbanSectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const KanbanSectionTitleAction = styled.button`
  display: flex;
  align-items: flex-start;
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0 0 12px;
  /* color: ${(props) => props.theme.colors.faceliftBlue}; */
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  text-decoration: underline;
  cursor: pointer;
  opacity: 0.85;

  &:hover {
    opacity: 1;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const KanbanDroppable = styled.div`
  ${(props) => (props.$loading ? shimmerOverlay : null)}
  min-height: ${(props) => (props.$split ? "415px" : "calc(100% - 33px)")};
  height: ${(props) => (props.$split ? "100%" : "50%")};
  flex: ${(props) => (props.$split ? "1 1 auto" : "0 0 auto")};
  display: flex;
  width: 360px;
  flex-direction: column;
  border-radius: 8px;
  position: relative;
  background: linear-gradient(0deg, rgba(24, 31, 56, 0) 0%, rgba(24, 31, 56, 0) 100%);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 8px;
    background: linear-gradient(0deg, rgba(24, 31, 56, 0) 0%, rgba(24, 31, 56, 0.03) 100%);
    opacity: ${(props) => (props.isEmpty ? 1 : 0)};
    transition: opacity 0.2s ease-in-out;
    pointer-events: none;
  }

  .body-item-scrollable {
    display: flex;
    overflow-y: scroll;
    align-items: center;
    gap: 16px;
    flex-direction: column;
    padding-bottom: 83px;
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  @media (max-width: 992px) {
    padding-bottom: 75px;
    width: 280px;
    height: calc(100% - 125px);
  }
`;

export const KanbanCardSelectAllInput = styled.input`
  position: absolute;
  top: 4px;
  right: 16px;
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  cursor: pointer;
  height: 15px;
  width: 15px;
  border: 1px solid rgba(68, 74, 94, 0.6);
  background-color: #fff;
  appearance: none;
  border-radius: 3px;
  transition: 0.1s opacity ease-in-out;

  ${KanbanContainerWrapper}:hover & {
    opacity: 1;
  }

  &[type="checkbox"]:focus {
    outline: none;
    box-shadow: none;
  }

  &[type="checkbox"]::before {
    position: absolute;
    content: "";
    width: 15px;
    height: 15px;
    opacity: 0;
    transition: 0.1s opacity ease-in-out;
    background-image: url(${checkmark});
    background-size: cover;
    background-position: center;
    left: -1px;
    top: -1px;
  }

  &[type="checkbox"]:checked::before {
    opacity: 1;
  }

  &[disabled] {
    display: none;
  }
`;
